module.exports = __webpack_public_path__ + "img/simon-fraser-university.3342ff6e.webp";